import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
      path: '/',
      redirect: '/login' // 将根路径重定向到登录页
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/elder',
    name: 'Elder',
    component: () => import('../views/Elder/Elder.vue')
  },
  {
    path: '/elder/user/me',
    name: 'User_Elder',
    component:() => import('../views/Elder/User_elder.vue')
  },
  {
    path: '/elder/AEldserve',
    name: 'AEldserve',
    component:() => import('../views/Elder/AEldserve.vue')
  },
  {
    path: '/elder/Healthy',
    name: 'ElderHealthyManage',
    component:() => import('../views/Elder/ElderHealthyManage.vue')
  },
  {
    path: '/family',
    name: 'Family',
    component: () => import('../views/Family/Family.vue')
  },
  {
    path: '/family/user/me',
    name: 'User_Family',
    component:() => import('../views/Family/User_family.vue')
  },
  {
    path: '/family/Healthy',
    name: 'FHealthyManage',
    component:() => import('../views/Family/FHealthyManage.vue')
  },
  {
    path: '/manager',
    name: 'Manager',
    component:() => import('../views/Manager/Manager.vue')
  },
  {
    path: '/users',
    name: 'Users',
    component:() => import('../views/Manager/User.vue')
  },
  {
    path: '/users/Aserve',
    name: 'Aserve',
    component:() => import('../views/Manager/Aserve.vue')
  },
  {
    path: '/users/AservePublishing',
    name: 'AservePublishing',
    component:() => import('../views/Manager/AservePublishing.vue')
  },
  {
    path: '/manager/healthy',
    name: 'HealthyManage',
    component: () => import('../views/Manager/HealthyManage.vue')
  },
]



const router = createRouter({
  history: createWebHistory(),
  routes
})


// 全局fetch拦截器添加token
const originalFetch = window.fetch;
window.fetch = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  if (token) {
    options.headers = {
      ...options.headers,
      'token': `${token}`
    };
  }
  return originalFetch(url, options);
}

export default router
